import styled, { css } from 'styled-components';
import { useState } from 'react';
import ErrorMemoModal from './ErrorMemoModal';

const ErrorDashboardTableItem = ({ error, idx, done }) => {
  const [isModal, setIsModal] = useState(false);

  return (
    <>
      {isModal && (
        <ErrorMemoModal
          closeModal={() => setIsModal(false)}
          id={error.id}
          done={done}
        />
      )}
      <ErrorDashboardTableItemBlock onClick={() => setIsModal(true)}>
        <Col className="cell-s">{idx}</Col>
        <Col>{error.formatedCreatedAt}</Col>
        {done && <Col>{error.doneAt}</Col>}
        <Col>{error.company}</Col>
        <Col>{error.name}</Col>
        <Col className="cell-s">{error.deviceType}</Col>
        <Col>{error.macAddress ? error.macAddress : '미입력'}</Col>
        <Col className="status" done={done}>
          {error.notificationType}
        </Col>
      </ErrorDashboardTableItemBlock>
    </>
  );
};

export default ErrorDashboardTableItem;

const ErrorDashboardTableItemBlock = styled.div`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 12px;
  cursor: pointer;
  &:last-child {
    margin-bottom: 20px;
  }
`;

const Col = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  ${props =>
    props.done &&
    css`
      text-decoration: line-through;
    `}
`;
